<script setup lang="ts">
import { useSlots } from 'vue';
const slots = useSlots();
</script>
<template>
  <div
    class="flex grid-cols-2 flex-col md:grid md:h-full md:grid-cols-[1fr_360px]"
  >
    <div class="relative max-h-full overflow-hidden bg-black">
      <slot name="gallery"> </slot>
    </div>

    <div class="flex h-full flex-col overflow-y-auto bg-white p-4">
      <slot name="header" />
      <div>
        <slot name="default" />
      </div>
      <div v-if="slots.meta" class="peer/meta">
        <slot name="meta" />
      </div>

      <slot name="footer" />

      <div>
        <slot name="actions" />
      </div>
      <div v-if="slots.comments">
        <slot name="comments" />
      </div>
    </div>
  </div>
</template>
